import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UsioMarkAsCancelledEvent = BaseLoanEvent.extend({
  type: z.literal('usioMarkAsCancelled'),
  paymentId: PaymentId,
});
export type UsioMarkAsCancelledEvent = z.infer<typeof UsioMarkAsCancelledEvent>;
